import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { Col } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';

import PanelWrapper from '../../components/ManageListing/PanelWrapper';
import Loader from '../../components/Loader';

// Graphql
import ManageListingsQuery from './manageListing.graphql';
import { withQuery } from '../../hoc/withGraphql';

import cs from '../../components/commonStyle.css'
import s from './ManageListing.css';

const ManageListing = (props) => {

  const { ManageListingsData, ManageListingsData: { ManageListings } } = props;

  return (
    <Col xs={12} sm={12} md={8} lg={8} className={cs.spaceTop6}>
      {
        !ManageListings && <Loader type={"text"} />
      }
      {
        ManageListings && <PanelWrapper data={ManageListingsData} />
      }
    </Col>
  );
}

ManageListing.propTypes = {
  ManageListingsData: PropTypes.shape({
    loading: PropTypes.bool,
    ManageListings: PropTypes.array
  })
};

ManageListing.defaultProps = {
  ManageListingsData: {
    loading: true,
    ManageListings: []
  }
}

export default compose(
  withStyles(cs, s),
  withQuery(ManageListingsQuery, {
    name: 'ManageListingsData',
    options: {
      ssr: false,
      fetchPolicy: 'network-only'
    }
  }),
)(ManageListing);